<template>
  <sc-page :title="schema.title" :desc="schema.desc" ref="table">
    <div class="body">
      <widget-table-button :buttons="buttons" />
      <a-table :data-source="listData.list">
        <a-table-column key="name" title="问题" data-index="name">
          <template v-slot="scope">
            <div @click="open(scope.record)">
              <a-button type="link">{{ scope.record.name }}</a-button>
            </div>
          </template>
        </a-table-column>
      </a-table>
      <!--    分页    -->
      <widget-table-pagination
        :count="listData.count"
        v-model:page-num="tableService.listConfig.pageNum"
        v-model:page-size="tableService.listConfig.pageSize"
      />
      <a-back-top :target="backTopTarget" :visibilityHeight="100" />
    </div>
  </sc-page>
</template>
<script setup lang="ts">
import { ComponentPublicInstance, ref, shallowRef, watch } from 'vue';
import WidgetTablePagination from '@/components/business/crud/table/WidgetTablePagination.vue';
import WidgetTableButton from '@/components/business/crud/table/WidgetTableButton.vue';
import { createCrudTableService } from '@/components/business/crud/service/CrudTableService';
import ScPage from '@/components/common/page/ScPage.vue';
import View from '@/views/management/help/View.vue';
import { windows } from '@/components/common/window/Windows';

const props = { moduleName: 'management', controllerName: 'help' };
const tableService = createCrudTableService(
  props.moduleName,
  props.controllerName
);
const { schema, listData,  buttons } = tableService.use();
tableService.listConfig.addLoad = ["content"];
tableService.init();

const table = ref<ComponentPublicInstance>();

function backTopTarget() {
  return table.value?.$el;
}

function open(record) {
  console.log(record)
  windows.open({
    content: {
      type: 'component',
      component: shallowRef(View),
      props: {
        content: record.content,
      },
    },
    title: record.name,
    width: 1280,
    height: 800,
  });
}
</script>

<style lang="scss" scoped>
.body {
  padding: $spacing-medium;
}

.ant-back-top {
  bottom: 100px;
  right: 100px;
}
</style>
